import React, { createContext, useContext, useState, useCallback } from 'react';
import en from '../translations/en';
import ar from '../translations/ar';

const translations = { en, ar };
const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => {
    try { return localStorage.getItem('lotsense_language') || 'en'; } catch { return 'en'; }
  });

  const setLanguage = useCallback((lang) => {
    setLanguageState(lang);
    try { localStorage.setItem('lotsense_language', lang); } catch {}
  }, []);

  const t = useCallback((key) => {
    const keys = key.split('.');
    let val = translations[language];
    for (const k of keys) {
      if (!val || typeof val !== 'object') return key;
      val = val[k];
    }
    return val || translations.en?.[keys[0]]?.[keys[1]] || key;
  }, [language]);

  const isRTL = language === 'ar';

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
